const config = {
    apiKey: "AIzaSyA6HNgK6e_mWkplcm_Sz2lnL0YnbzRYOYo",
    authDomain: "bleachlivechat.firebaseapp.com",
    databaseURL: "https://bleachlivechat.firebaseio.com",
    projectId: "bleachlivechat",
    storageBucket: "bleachlivechat.appspot.com",
    messagingSenderId: "300056204010",
    appId: "1:300056204010:web:8f5487636cc8b78664bd93",
    measurementId: "G-JVCZ2TLY22"
}

export default config